<template>
  <b-container fluid>
    <sp-card header="Contracheque Online">
      <b-row no-gutters>
        <b-col cols="12">
          <sp-form-select
            label="Suas lotações"
            v-model="costCenter"
            :options="costCenters"
            class="pr-lg-2"
            unique="id"
            text="nome"
            @change="fetchPaychecks(0)"
          />
          {{ costCenter }}
        </b-col>
        <b-col cols="12">
          <Table
            :paychecks="paychecks"
            :loading="loading"
            :total-elements="totalElements"
            :size-per-page="sizePerPage"
            @change-page="fetchPaychecks"
            @view="view"
          />
        </b-col>
      </b-row>
      <Modal ref="modal" />
    </sp-card>
  </b-container>
</template>
<script>
import Table from '@/components/paycheck/Table.vue';
import Modal from '@/components/paycheck/Modal.vue';
import { userService } from '@/services';

export default {
  components: { Table, Modal },
  data() {
    return {
      costCenter: '',
      costCenters: [],
      paychecks: [],
      loading: false,
      totalElements: 0,
      sizePerPage: 20,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.fetchAlocations();
    },
    async fetchAlocations() {
      this.costCenters = await userService.listCostCenters();
      if (this.costCenters.length > 0) this.costCenter = this.costCenters[0].id;
      this.fetchPaychecks(0);
    },
    async fetchPaychecks(page) {
      this.loading = true;
      const { content, totalElements } = await userService.listPaychecks(this.costCenter, page);
      this.paychecks = content;
      this.totalElements = totalElements;
      this.loading = false;
    },
    async view(paycheck) {
      this.$refs.modal.show(paycheck);
    },
  },
};
</script>
